import { Handler } from '../../../Shared/Application/UseCases/Handler';
export class GetProductBySkuHandler extends Handler {
  constructor(productRepository) {
    super();
    this.productRepository = productRepository;
  }
  handle(input) {
    return this.productRepository.findBySku(input.sku, input.territory, input.projectID, input.userID);
  }
}
